// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sweep-login {\n  padding: 14px 45px 32px;\n  width: 390px;\n  height: 290px;\n  position: relative;\n}\n.sweep-login::after {\n  content: '打开企业微信 扫描二维码';\n  display: block;\n  clear: both;\n  width: 100%;\n  font-size: 14px;\n  text-align: center;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n.sweep-login #wx_reg {\n  height: 222px;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
